// Full navigation configuration matching reference project

export const mbbsSubmenu = [
  { href: '/student-life', label: 'Student Life in Russia', desc: 'Food, hostels, community & daily life', icon: 'GraduationCap' },
  { href: '/weather-in-russia', label: 'Weather in Russia', desc: 'All regional climates & seasonal guide', icon: 'Thermometer' },
  { href: '/india-russia-travel', label: 'India → Russia Travel', desc: 'Flights, visas, documents & arrival tips', icon: 'Plane' },
  { href: '/india-russia-relations', label: 'India–Russia Relations', desc: '75+ years of bilateral friendship', icon: 'Handshake' },
  { href: '/regional-connectivity', label: 'Moscow to Regional Cities', desc: 'How to reach your university from Moscow', icon: 'Train' },
  { href: '/alumni', label: 'Our Alumni', desc: '1,200+ graduates — their stories & journeys', icon: 'Award' },
];

export const examSubmenu = [
  { href: '/exams/fmge', label: 'FMGE Exam', desc: 'India licensing for foreign MBBS graduates', icon: 'ClipboardList' },
  { href: '/exams/next', label: 'NExT Exam', desc: "India's new unified medical exit test", icon: 'Medal' },
  { href: '/exams/admission-russia', label: 'Admission Exam (Russia)', desc: 'University entry test upon arrival', icon: 'GraduationCap' },
  { href: '/exams/semester-annual', label: 'Semester & Annual Exams', desc: 'Ongoing academic assessment in Russia', icon: 'CalendarDays' },
  { href: '/exams/final-state', label: 'Final State Exam', desc: 'Graduation exam for Russian MBBS degree', icon: 'Flag' },
];

export const eventsSubmenu = [
  { href: '/upcoming-events', label: 'Upcoming Events', desc: 'City seminars, webinars & counselling sessions', icon: 'Calendar' },
  { href: '/news', label: 'News & Updates', desc: 'Latest on MBBS Russia, NMC & Indian medical policy', icon: 'Newspaper' },
  { href: '/seminar', label: 'Guidance Seminar', desc: 'Free MBBS-in-Russia offline seminar in your city', icon: 'Users' },
  { href: '/accommodation', label: 'Accommodation', desc: 'University hostels & private housing options', icon: 'HomeIcon' },
];

export const servicesSubmenu = [
  { href: '/services', label: 'All Services', desc: 'Complete overview of our 9 core services', icon: 'Award' },
  { href: '/visa-support', label: 'Visa Support', desc: 'Student visa assistance — 99% success rate', icon: 'ShieldCheck' },
  { href: '/accommodation', label: 'Accommodation', desc: 'University hostels & private housing options', icon: 'HomeIcon' },
  { href: '/video-counselling', label: 'Video Counselling', desc: '1-on-1 free online counselling sessions', icon: 'Users' },
];

export const moreSubmenu = [
  { href: '/admission-process', label: 'Admission Process', desc: 'Simplest 6-step MBBS admission procedure', icon: 'ClipboardList' },
  { href: '/universities/fees', label: 'Fees Comparison', desc: 'Side-by-side yearly & 6-year cost for all universities', icon: 'Coins' },
  { href: '/nmc-regulations', label: 'NMC Regulations for MBBS Abroad', desc: 'Latest NMC rules & FMG eligibility criteria', icon: 'ShieldCheck' },
  { href: '/faqs', label: 'FAQs', desc: 'Safety, degree, hostel, food & more answered', icon: 'HelpCircle' },
  { href: '/gallery', label: 'Photo & Video Gallery', desc: 'Campus, events, alumni & city tours in visuals', icon: 'Camera' },
  { href: '/upcoming-events', label: 'Upcoming Events', desc: 'City seminars, webinars & counselling sessions', icon: 'Calendar' },
  { href: '/news', label: 'News & Updates', desc: 'Latest on MBBS Russia, NMC & Indian medical policy', icon: 'Newspaper' },
  { href: '/seminar', label: 'Guidance Seminar', desc: 'Free MBBS-in-Russia offline seminar in your city', icon: 'Users' },
  { href: '/accommodation', label: 'Accommodation', desc: 'University hostels & private housing options', icon: 'HomeIcon' },
  { href: '/alumni', label: 'Our Alumni', desc: '1,200+ graduates — their stories & journeys', icon: 'Award' },
  { href: '/video-counselling', label: 'Video Counselling', desc: '1-on-1 free online counselling sessions', icon: 'Users' },
];

export const mainNav = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'MBBS in Russia', href: '/mbbs-in-russia', children: mbbsSubmenu },
  { label: 'Universities', href: '/universities', special: 'universities' },
  { label: 'Exams', href: '/exams', children: examSubmenu },
  { label: 'Services', href: '/services', children: servicesSubmenu },
  { label: 'More', href: '/admission-process', children: moreSubmenu },
];
